"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MoonSpace = void 0;
const vue_1 = require("vue");
const TileType_1 = require("../../TileType");
const i18n_1 = require("../../directives/i18n");
const tileTypeToCssClass = new Map([
    [TileType_1.TileType.MOON_ROAD, 'road'],
    [TileType_1.TileType.MOON_COLONY, 'colony'],
    [TileType_1.TileType.MOON_MINE, 'mine'],
    [TileType_1.TileType.LUNA_TRADE_STATION, 'luna-trade-station'],
    [TileType_1.TileType.LUNA_MINING_HUB, 'luna-mining-hub'],
    [TileType_1.TileType.LUNA_TRAIN_STATION, 'luna-train-station'],
    [TileType_1.TileType.LUNAR_MINE_URBANIZATION, 'lunar-mine-urbanization'],
]);
exports.MoonSpace = vue_1.default.component('moon-space', {
    props: {
        space: {
            type: Object,
        },
        text: {
            type: String,
        },
    },
    data: function () {
        return {};
    },
    components: {},
    methods: {
        getVerboseTitle: function (tileType) {
            let ret = '';
            if (tileType === TileType_1.TileType.LUNA_TRADE_STATION) {
                ret = 'Luna Trade Station';
            }
            else if (tileType === TileType_1.TileType.LUNA_MINING_HUB) {
                ret = 'Luna Mining Hub';
            }
            else if (tileType === TileType_1.TileType.LUNA_TRAIN_STATION) {
                ret = 'Luna Train Station';
            }
            else if (tileType === TileType_1.TileType.MOON_COLONY) {
                ret = 'Moon Colony: 1 VP per adjacent Road';
            }
            else if (tileType === TileType_1.TileType.MOON_MINE) {
                ret = 'Moon Mine: 1 VP per adjacent Road';
            }
            else if (tileType === TileType_1.TileType.MOON_ROAD) {
                ret = 'Moon Road: 1 VP';
            }
            return i18n_1.$t(ret);
        },
        getMainClass: function () {
            let css = 'board-space moon-space-' + this.space.id.toString();
            css += ' board-space-selectable';
            const tileType = this.space.tileType;
            if (tileType !== undefined) {
                switch (this.space.tileType) {
                    case TileType_1.TileType.MOON_COLONY:
                        css += ' board-space-tile--colony';
                        break;
                    case TileType_1.TileType.MOON_ROAD:
                        css += ' board-space-tile--road';
                        break;
                    case TileType_1.TileType.MOON_MINE:
                        css += ' board-space-tile--mine';
                        break;
                    default:
                        const cssClass = tileTypeToCssClass.get(tileType);
                        css += ' board-space-tile--' + cssClass;
                }
            }
            else {
                if (this.space.spaceType === 'lunar_mine') {
                    css += ' moon-space-type-mine';
                }
                else {
                    css += ' moon-space-type-other';
                }
            }
            return css;
        },
    },
    template: `
        <div :class="getMainClass()" :data_space_id="space.id" :title="getVerboseTitle(space.tileType)">
            <div class="board-space-text" v-if="text" v-i18n>{{ text }}</div>
            <bonus :bonus="space.bonus" v-if="space.tileType === undefined"></bonus>
            <div :class="'board-cube board-cube--'+space.color" v-if="space.color !== undefined"></div>
        </div>
    `,
});
//# sourceMappingURL=MoonSpace.js.map